<template>
  <v-btn icon dense :class="$style.remove" color="primary" v-bind="$attrs" @click="$emit('delete')">
    <IconSelect
      icon="trash"
      :height="defaultIconSize"
      :width="defaultIconSize"
      :class="$style['trash-icon']"
    />
  </v-btn>
</template>

<script>
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'BasketProductRemove',
  components: {
    IconSelect,
  },
  data() {
    return {
      defaultIconSize: 24,
    }
  },
}
</script>

<style lang="scss" module>
.remove {
  display: flex;
  align-items: center;
  justify-content: center;
}

.trash-icon {
  width: 24px;
  height: 24px;
}

// .trash-icon {
//   color: var(--primary);
// }
</style>
